import { useEffect, useMemo } from "react";
import { getConsentsToAccept, useConsentsSelector } from "@nf/common";
import { ROUTES } from "@nf/constants";
import { useSyncCompleted } from "./useSyncWebUser";
import { useRouter } from "./useRouter";

export const useRedirectToConsentPage = (isLoggedIn?: boolean) => {
  const { isLoading, consents } = useConsentsSelector();
  const isAuthProcessCompleted = useSyncCompleted();
  const router = useRouter();

  const shouldUpdateConsents = useMemo(
    () =>
      isAuthProcessCompleted &&
      isLoggedIn &&
      !!getConsentsToAccept(consents)?.length,
    [consents, isAuthProcessCompleted, isLoggedIn]
  );

  useEffect(() => {
    if (!isLoading && shouldUpdateConsents) {
      router.replace(ROUTES.UPDATED_TERMS_SCREEN);
    }
  }, [shouldUpdateConsents, isLoading]);
};
